<span [innerHtml]="text | cleanhtml | iconize" data-testid="button-text"></span>
